<template>
	<!-- 页脚 -->
  <section class="bottom-wrap" style="display: grid; grid-template-columns: 720px auto 260px;">
    <div class="msg">
      <div class="contact" style="display: grid; grid-template-columns: auto auto;">
        
      </div>
      <div class="tips">
        <div style="font-size: 14px">
          Copyright @ 2015-2024 congting.com All rights reserved&nbsp;&nbsp;&nbsp;&nbsp;京ICP备16024387号-13 京公网安备 11011402012378号
        </div>
      </div>
    </div>
    <div></div>
    <div class="code" style="display: grid; grid-template-columns: auto auto; column-gap: 20px">
      
      <div>
        <div class="qr-code">
          <img :src="require('@/assets/qrcode.jpg')" >
        </div>
        <div class="qr-title">公众号</div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {

      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  .bottom-wrap{
    width: 100%;
    height: 190px;
    background: #3A404E;
    padding: 35px 100px 30px;
    color: #fff;
	box-sizing: border-box;
  }

  .msg{
    display: inline-block;
    vertical-align: top;
    .contact{
      margin-bottom: 50px;
      span{
        margin-right: 30px;
      }
    }
    .tips{
      line-height: 1.8;
    }
  }
  .code{
    margin-top: -15px;
    display: inline-block;
    float: right;
    .qr-code{
      width: 100px;
      height: 100px;
      padding: 10px;
      background-color: #fff;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .qr-title{
      width: 100px;
      text-align: center;
      margin-top: 15px;
      margin-left: 15px;
      font-size: 14px;
    }
  }
</style>
